import { initialIntegrationCategories } from '@/app/(dashboard)/integrations/integrations';

export type PartnerLogo = { src: string; alt: string };

// Local fallbacks to supplement the dashboard sources.
const LOCAL_LOGOS: PartnerLogo[] = [
  { src: '/integrations/lever.png', alt: 'Lever' },
  { src: '/integrations/deel.png', alt: 'Deel' },
  { src: '/integrations/bamboohr.png', alt: 'BambooHR' },
  { src: '/integrations/rippling.jpeg', alt: 'Rippling' },
  { src: '/partners/vensure.png', alt: 'VensureHR' },
];

function normalizeLogoSrc(logo: unknown): string | null {
  if (!logo) return null;
  if (typeof logo === 'string') return logo;
  if (typeof logo === 'object' && logo !== null && 'src' in logo)
    return (logo as { src: string }).src;
  return null;
}

/**
 * Merge partner / integration logos from the dashboard integration categories
 * and local fallbacks, de-duplicated by `src`.
 * Shared by the marquee on the products page and the sponsors grid.
 */
export function getPartnerLogos(): PartnerLogo[] {
  const dashboardLogos: PartnerLogo[] = (initialIntegrationCategories || [])
    .flatMap(cat => cat.items || [])
    .map(item => ({ src: normalizeLogoSrc(item.logo) || '', alt: item.name }))
    .filter(l => !!l.src);

  const seen = new Set<string>();
  return [...dashboardLogos, ...LOCAL_LOGOS].filter(l => {
    if (!l.src || seen.has(l.src)) return false;
    seen.add(l.src);
    return true;
  });
}
